import React, { useState } from "react";
import { Badge, Button, Card, Popconfirm, Spin, Icon, Tooltip, Tag, Alert } from "antd";
import { MerchantService } from "../../services";
import { handleApiExceptions, alertify, printRupee } from "../../app_methods";
import { connect } from "react-redux";
import { updateCurrentUserAction } from "../../redux/actions";
import { getBankLogo } from '../../constants';
import { Text2, Text3 } from "../../styles";
import { PermissionHoc } from "../HOC";
import _ from "lodash";
import { VirtualAccountSettingsModal } from "./virtual_account_settings_modal";
import CreditCardModal from "../Common/CreditCardModal";
import { Link } from "react-router-dom"
import Alloted_connected_banking_drawer from "../Merchants/List/alloted_connected_banking_drawer";


const PermissableIcon = PermissionHoc(Icon, "VIRTUAL_ACCOUNTS_WRITE", { is_component: true, fallbackComponent: null })
const PermissableButton = PermissionHoc(Button, "VIRTUAL_ACCOUNTS_WRITE", { is_component: true, fallbackComponent: null })
const PermissablePopConfirm = PermissionHoc(Popconfirm, "VIRTUAL_ACCOUNTS_WRITE", { is_component: true, fallbackComponent: null })

const VirtualAccountsSettings = (props) => {
    const [isFetching, setIsFetching] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
    const [virtualAccountSettingsModal, setVirtualAccountSettingsModal] = useState(false);
    const [selectedVirtualAccount, setSelectedVirtualAccount] = useState({});
    const [showCrediCardModal, setShowCreditCardModal] = useState(false);
    const userPermissions = props?.current_user?.user?.permissions;
    const [showSubWallet, setShowSubWallet] = useState(false);

    const toggleCreditCardModal = (data = {}) =>{
        setSelectedVirtualAccount(data);
        setShowCreditCardModal(!showCrediCardModal)
    }

	const fetchMerchantInfo = () => {
        setIsFetching(true);
		MerchantService.fetch().then((response) => {
			if (response.success) props.updateCurrentUser(response.data.merchant);
            setIsFetching(false);
		});
	};

	const activateVA = async (virtual_account) => {
        setIsLoading(true);
        const response = await MerchantService.activate_virtual_account({
            id:virtual_account.id,
            virtual_account_number: virtual_account.virtual_account_number,
            key: props.current_user.key,
        });
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", "Virtual Account activated successfully.", "success");
        fetchMerchantInfo();
        setIsLoading(false);
	};
    
    const toggleVirtualAccountSettingsModal = (data = {}) => {
        setSelectedVirtualAccount(data);
        setVirtualAccountSettingsModal(!virtualAccountSettingsModal);
    }

    const onSuccessSettingsUpdate = () => {
        fetchMerchantInfo();
        toggleVirtualAccountSettingsModal();
        alertify("Success!", "Settings updated successfully.", "success");
    }

    
    const renderActive = (va) => {
        return va.active ?
            <Badge color="green" text="Active" />
            :
            <Tooltip title={va.funding_via==2 && !(props.current_user.enable_funding_via_credit_card && props.current_user.allow_payouts_via_cc_va)?"Virtual accounts which can be funded by credit cards cannot be used for generating pay-outs.":null} className="mr-1" trigger="hover">
                <PermissablePopConfirm
                    disabled= {va.funding_via==2 && !(props.current_user.enable_funding_via_credit_card && props.current_user.allow_payouts_via_cc_va)?true:false}
                    title="Are you sure you want to activate this Virtual Account?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => activateVA(va)}
                >
                    <PermissableIcon type="check" twoToneColor="green" style={{ fontSize: 12 }} /> Activate
                </PermissablePopConfirm>
            </Tooltip>        
    };
    const renderDeactivated = (va) => {
        return (
            <span style={{color: 'rgba(0, 0, 0, 0.45)'}} className="text-align-center font-weight-bold pe-none">Closed</span>
            )
    }

    const AccountCards = ({title, data}) => {

        const renderSettingsBtn = (va) =>{
            return (
                <div className="d-flex align-items-center justify-content-center" onClick={() => {if (!isFetching) toggleVirtualAccountSettingsModal(va);}}>
                     <Icon className="mr-1" type="setting" key="setting" style={{ fontSize: 12 }} /> Settings
                </div> 
            )
        }

        const renderSubWalletBtn = (va) =>{
            return (
                <div className="d-flex align-items-center justify-content-center" onClick={() => {setSelectedVirtualAccount(va) ; setShowSubWallet(true)}}>
                     <Icon className="mr-2" type="wallet" key="wallet" style={{ fontSize: 12 }} /> Subwallets
                </div> 
            )
        }

        const cardFooter = (va) => {
            if(va.status==="deactivated"){
                return [renderDeactivated(va)]
            }

            if(userPermissions.includes("VIRTUAL_ACCOUNTS_WRITE") ){
                if (props.current_user?.enable_sub_wallet){
                    return [renderActive(va), renderSettingsBtn(va),renderSubWalletBtn(va)]
                }
                return [renderActive(va), renderSettingsBtn(va)]
            } else if (va.active){
                return [renderActive(va),renderSubWalletBtn(va)]
            }else return false;
        } 
    
        return (
            <>
                <Text2 className=" mb-2 mt-2 d-block" strong>{title}</Text2>
                    <div className="d-flex flex-wrap">
                    {data.map(va => {
                        return (
                            <Card
                                className={`d-flex flex-column justify-content-between ${va.status===`deactivated` && `deactivated-payout-account-card`} rounded shadow-sm mb-4 mr-2`}
                                style={{ width: 300, paddingTop: "0.5rem" }}
                                title={false}
                                actions={cardFooter(va)}
                            >
                                <div className="pl-2 d-flex justify-content-between mb-2">
                                    <div className="d-flex align-items-center w-100">
                                        <div className="d-flex mr-2" style={{width: 45,overflow: "hidden",textAlign: "center",height: "auto"}}>
                                            <img style={{margin: "auto",width: "auto",maxWidth: "100%",maxHeight: "auto"}} alt="" src={getBankLogo(va.provider?.code)}/>
                                        </div>
                                        <Text3 strong>{va.provider_name}</Text3>
                                        {((va.is_connected_banking || va.is_bipatriate_escrow) && !["IDFC Bank", "Axis Bank", "SBI Bank", "NSDL Bank"].includes(va.provider_name)) && <Tag color="blue" className="" style={{fontSize: "12px",marginLeft: "auto"}}>{_.capitalize(va.account_type)} Account</Tag>}
                                    </div>
                                </div>
                                <div className="pl-3 mb-2">
                                    <>
                                        <Text3 className="d-block">{va.label}</Text3>
                                        {va.funding_via == 1 && !va.is_alloted_connected_banking ? <Text3 className="d-block" type="secondary">{va.virtual_ifsc_number}</Text3> : <></>}
                                    </>
                                    <Text3 className="d-block" type="secondary">{printRupee(va.balance, 3)}</Text3>
                                    {va.funding_via == 2 && props.current_user.enable_funding_via_credit_card ? <PermissableButton className="px-0" type="link" onClick={() => toggleCreditCardModal(va)}>+ Add Funds</PermissableButton> : <></>}
                                </div>
                            </Card>
                        )
                    })}
                </div>
                <Alloted_connected_banking_drawer
                    visible={showSubWallet}
                    toggleAllotedConnectedBankingDrawer={()=>setShowSubWallet(!showSubWallet)}
                    merchant={props.current_user}
                    fetchMerchants={()=>console.log('none')}
                    isSubWallet={true}
                    selectedVirtualAccount={selectedVirtualAccount}
                />
            </>)
    };

    const renderAccounts = (accs) => {
        const connectedBankingAccounts = [];
        const virtualAccounts = [];
        const closedAccounts = [];
        console.log(accs)
        accs.filter(va=>!va.is_sub_wallet).forEach((obj)=>{
            if (obj.is_connected_banking === true && obj.status === 'active') connectedBankingAccounts.push(obj);
            else if ((obj.is_connected_banking === false && obj.status === 'active') ) virtualAccounts.push(obj);
            else if (obj.status === 'deactivated') closedAccounts.push(obj);
        });

        return (
            <>
                <Alert
                type="info"
                className="mb-4"
                message="Important Notification - Virtual Account Funding"
                showIcon
                closable
                description={
                    <div>
                        Only the current account (linked to your PAN & verified by Easebuzz) can be used for depositing funds in the virtual account. Funds received from unverified accounts would be automatically refunded to the source account.<br />
                        <Link className='mx-0 pl-0 pr-0' to='/settings/funding-accounts'>Click Here</Link> to whitelist your current account with Easebuzz.
                    </div>
                }/>
                
                {virtualAccounts.length !== 0 && <AccountCards data={virtualAccounts} title={connectedBankingAccounts.length !== 0 && "Virtual Accounts"} />}
                {connectedBankingAccounts.length !== 0 && <AccountCards data={connectedBankingAccounts} title={virtualAccounts.length !== 0 && "Connected Banking Accounts"}/>}
                {closedAccounts.length !== 0 && <AccountCards data={closedAccounts} title="Closed Accounts"/>}
            </>

        )
    }

	return (
        <Spin tip="Loading..." spinning={isLoading}>
            {renderAccounts(props.current_user.virtual_accounts)}
            <CreditCardModal
            visible={showCrediCardModal}
            onCancel={toggleCreditCardModal}
            virtualAccount={selectedVirtualAccount}>
            </CreditCardModal>

            <VirtualAccountSettingsModal
                visible={virtualAccountSettingsModal}
                toggleVirtualAccountSettingsModal={toggleVirtualAccountSettingsModal}
                virtualAccount={selectedVirtualAccount}
                onSuccess={onSuccessSettingsUpdate}
            ></VirtualAccountSettingsModal> 
        </Spin>
	);
};

const mapStateToProps = (state) => ({
	current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
	updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(VirtualAccountsSettings,"VIRTUAL_ACCOUNTS_READ"));
